import { useT } from "../i18n/context";
import { send } from "../ws/singleton";

/**
 * The table has been playing this seat because its player kept running out of time (decision 173).
 * Their own screen says so and gives the seat back on one tap; playing a card does the same.
 */
export function AutoBanner({ dense }: { dense: boolean }) {
  const { t } = useT();
  return (
    <div
      role="status"
      className={`flex w-full items-center justify-center gap-3 rounded-pill border-[1.5px] border-gold/60 bg-panel-strong px-4 ${dense ? "h-9 text-[12px]" : "h-11 text-[13px]"}`}
    >
      <span className="font-semibold text-ink/85">{t("table.auto.title")}</span>
      <button
        type="button"
        className="btn-gold h-8 rounded-pill px-4 text-[12px] font-extrabold"
        onClick={() => send({ type: "takeOver" })}
      >
        {t("table.auto.take")}
      </button>
    </div>
  );
}
